import { FC, memo, useState } from "react";
import { useTranslation } from "react-i18next";
import { call } from "@/services/call";
import { logger } from "@/services/logger";
import { Select } from "@/ui";
import { showErrorToast } from "@/utils/toast";
import { StyledCameraSelect } from "./styled";

const CameraSelect: FC = () => {
  const {t} = useTranslation();

  const [loading, setLoading] = useState(false);
  const [value, setValue] = useState(call.devices?.currentVideoDeviceId || '');

  const onChange = async (e: string) => {
    try {
      setLoading(true);
      setValue(e);
      await call.switchVideo(e);
    } catch (error) {
      logger.error(error);
      showErrorToast(t('error'), t('something_went_wrong'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <StyledCameraSelect>
      <h4>{t('select_camera')}</h4>
      <Select
        options={call.devices?.videoDevices.map((item) => ({ label: item.label, value: item.deviceId })) || []}
        value={value}
        onChange={onChange}
        disabled={loading}
      />
    </StyledCameraSelect>
  );
};

export default memo(CameraSelect);
